<template>
    <div class="app-breadcrumbs">
        <transition appear name="fade" mode="out-in">
            <ul v-if="breadcrumbs && breadcrumbs.length" class="app-breadcrumbs__list">
                <li v-for="(crumb, index) in breadcrumbs" :key="index" class="app-breadcrumbs__item">
                    <span v-if="index > 0" class="app-breadcrumbs__divider">/</span>

                    <app-link :to="crumb.to" class="app-breadcrumbs__link">
                        <v-icon v-if="crumb.icon" x-small class="app-breadcrumbs__icon">
                            {{ getIcon(crumb.icon, 'fas') }}
                        </v-icon>
                        <span class="app-breadcrumbs__heading">
                            {{ crumb.heading }}
                        </span>
                    </app-link>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'AppBreadcrumbs',
    computed: {
        breadcrumbs() {
            let crumbs = this.$store.getters['app/breadcrumbs'];

            if (crumbs.length <= 0) {
                return [];
            }

            // Resolve routes

            crumbs = crumbs.map(crumb => {
                if (crumb.to) {
                    crumb.route = this.$router.resolve(crumb.to)?.route || null;
                } else if (crumb.heading) {
                    crumb.route = this.$router.resolve({ name: crumb.heading })?.route || null;
                }

                if (crumb.route && !crumb.heading) {
                    crumb.heading = crumb.route.name;
                }

                return {
                    heading: crumb.heading,
                    icon: crumb.icon,
                    to: crumb.to,
                    route: crumb.route
                };
            });

            // Add home route

            const home = this.$router.resolve(this.home_route)?.route;

            if (!home) {
                return crumbs;
            }

            const first = crumbs[0];

            if (first.route.name !== home.name) {
                crumbs.unshift({
                    heading: home.meta.breadcrumb_label || home.name,
                    icon: 'home',
                    to: home,
                    route: home
                });
            } else {
                crumbs[0] = {
                    heading: crumbs[0].heading || home.meta.breadcrumb_label || home.name,
                    icon: 'home',
                    to: home,
                    route: home
                };
            }

            // Remove to property on crumbs that match current route

            crumbs = crumbs.map(crumb => {
                if (crumb.route && crumb.route.fullPath === this.$route.fullPath) {
                    crumb.to = null;
                }

                return crumb;
            });

            return crumbs;
        }
    }
};
</script>

<style lang="scss">
.v-application {
    .app-breadcrumbs {
        display: block;
        position: absolute;
        top: calc(var(--v-app-bar-top) + var(--v-app-bar-height));
        left: 0;
        right: 0;
        height: var(--v-app-breadcrumbs-height) !important;
        background: var(--v-background-base);
        &__list {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            list-style: none;
            padding: 0 1rem;
            margin: 0;
            height: 100%;
        }
        &__item {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 0;
            padding: 0;
            cursor: default;
        }
        &__link {
            > a,
            > span {
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }
        }
        &__icon {
            display: block;
            margin-right: 0.2rem;
        }
        &__heading {
            display: block;
            font-size: 0.8rem;
            padding-top: 0.1rem;
        }
        &__divider {
            display: block;
            margin: 0 0.4rem;
            font-size: 0.8rem;
        }
    }
}
</style>
